import React, { Component } from 'react';
import Portal from '../components/portal';
import { connect } from 'react-redux';
import { closeModal } from "../actions"
import ImagePreview from './Booking/imagepreview';
import UpdateProfileModal from './Booking/updateprofilemodal';
import TermsModal from './Booking/termsmodal';
import CallUsmodal from './Landing/callusmodal';
import LoginModal from './Home/loginmodal';
import RateCardModal from './Booking/ratecardmodal';
import OffersModal from './Booking/offermodal';
import HowitWorks from './Home/howitworksmodal';
import MenuModal from "./menumodal"
import BillModal from './Orders/billmodal';

class Modal extends Component {

    constructor(props){
        super(props);
        this.closeModal = this.closeModal.bind(this);
    }

    closeModal(){
        this.props.dispatch(closeModal())
    }   
    

    selectModal(){
        switch(this.props.modalName){
            case 'IMAGE_PREVIEW': 
                return ImagePreview;
            case 'UPDATE_PROFILE':
                return UpdateProfileModal;
            case 'TERMS_MODAL':
                return TermsModal;
            case 'CALL_US':
                return CallUsmodal;
            case "LOG_IN":
                return LoginModal;
            case 'RATE_CARD':
                return RateCardModal;
            case 'BILL':
                return BillModal;
            case 'OFFERS':
                return OffersModal;
            case 'HOW_IT_WORKS':
                return HowitWorks;
            case 'MENU_MODAL':
                return MenuModal;
            default:
                return null
        }
    }


    render() {
        const Modalbody = this.selectModal();
        return (
            this.props.open ?
            <Portal>
                <div className="modal-wrapper" onClick={this.closeModal}>
                    <div className="modal-container" onClick={(e) => e.stopPropagation()}>
                        {
                            Modalbody &&
                            <Modalbody {...this.props.modalProps} />
                        }
                    </div>
                </div>
            </Portal> : null
        )
    }
}

export default connect((state) => state.modalReducer )(Modal)
